import { useRef } from "react";

// a shorter drag is a tap or a wobble
const MIN_DISTANCE = 50;
// Safari takes swipes from the screen's edges for back and forward
const EDGE_WIDTH = 20;

// Touch handlers that call onSwipeLeft or onSwipeRight for a mostly horizontal swipe of one finger.
export default function useSwipe({ onSwipeLeft, onSwipeRight }) {
  const startRef = useRef(null);

  return {
    onTouchStart: (event) => {
      const touch = event.touches[0];
      const fromEdge = touch.clientX < EDGE_WIDTH || touch.clientX > window.innerWidth - EDGE_WIDTH;
      // a second finger, eg pinching, cancels the swipe
      startRef.current = event.touches.length === 1 && !fromEdge ? { x: touch.clientX, y: touch.clientY } : null;
    },
    onTouchEnd: (event) => {
      const start = startRef.current;
      startRef.current = null;
      if (!start) return;

      const touch = event.changedTouches[0];
      const dx = touch.clientX - start.x;
      const dy = touch.clientY - start.y;
      if (Math.abs(dx) < MIN_DISTANCE || Math.abs(dx) < 2 * Math.abs(dy)) return;

      if (dx < 0) onSwipeLeft?.();
      else onSwipeRight?.();
    },
    onTouchCancel: () => {
      startRef.current = null;
    },
  };
}
